<header class="px-4xl pt-4xl mb-4xl gap-xl bg-gray-modern-50 sticky top-0 z-50 flex flex-col">
  <bx-breadcrumbs
    [breadcrumbs]="breadcrumbOptions()"
    [type]="'text'"
    [divider]="'chevron'"
    [homeAriaLabel]="'system.aria.home' | translate"
    [navAriaLabel]="'system.aria.breadcrumb' | translate"
  ></bx-breadcrumbs>

  <div class="gap-xl flex">
    <div class="gap-xs flex flex-col items-start justify-start">
      <h1 class="text-text-primary-900 text-display-sm font-semibold">{{ title() }}</h1>

      @if (supportingTitle(); as supportingTitle) {
        <p class="text-text-tertiary-600">{{ supportingTitle }}</p>
      }
    </div>

    @if (headerContent(); as headerContent) {
      <ng-container *dynamicView="headerContent"></ng-container>
    }
  </div>
</header>

<div class="px-4xl pb-4xl flex flex-1 flex-col">
  <ng-content></ng-content>
</div>
